<template>
    <div class="layout-container table-special">
        <el-tabs  v-model="activeTabs" type="border-card" @tab-click="handleClick">
            <el-tab-pane name="1" label="话题内容建模管理">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_name" @created="initData"  :clueId=1  :owned="true" :init-choose-first="false" :dataType=1 :keyType=1 ref="siteAutoComplete"></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label" >执行状态</span>
                            <div class="input-condition" >
                                <el-select v-model="condition.type" placeholder="请选择">
                                    <el-option
                                        v-for="item in statusList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                        <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleAdd()"
                        v-permission="'operating.house-topic.house-topic-model.create'"
                        >新增任务</el-button>
                    </div>
                </div>
               
            <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="站点" prop="site_name_str"   align="center">
                     <template slot-scope="scope">
                        <p class="ellips" :title="scope.row.site_name_str">{{scope.row.site_name_str}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="审核状态" prop="status_verify_text" width="100"  align="center"></el-table-column>
                <el-table-column  label="生成时间段" prop="create_time_period" width="200"  align="center"></el-table-column>
                <el-table-column  label="生成结果" prop="pending,success,fail" width="250"  align="center">
                     <template slot-scope="scope">
                        <p>已生成：{{scope.row.success}}，失败：{{scope.row.fail}}，待生成：{{scope.row.pending}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="执行状态" prop="type_text" width="100"  align="center"></el-table-column>
                <el-table-column  label="最近执行时间" prop="type_text"  align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_error">
                            <span>{{scope.row.updated_at}}</span>
                            <el-tooltip effect="dark" :content="'任务可能存在异常，计划执行时间'+scope.row.execute_time" placement="bottom">
                                <i style="font-size:20px;margin-left: 10px;" class="el-icon-warning-outline"></i>
                            </el-tooltip>
                        </div>
                        <p v-else>{{scope.row.updated_at}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="操作人" prop="operator" width="100"  align="center"></el-table-column>
                <el-table-column  label="操作时间" prop="created_at"  align="center"></el-table-column>
                <el-table-column label="操作" width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button v-permission="'operating.house-topic.house-topic-model.record'"  size="mini" @click="openRecord(scope.row)"
                            >生成记录</el-button>
                        <el-button v-permission="'operating.house-topic.house-topic-model.terminated'" v-if="scope.row.type==1"  size="mini" @click="handleStop(scope.row.id)"
                            >终止生成</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <template v-if="list.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>
        </el-tab-pane>
        <el-tab-pane name="2" label="生成任务预览">
            <task-preview ref="taskPreviewRef"></task-preview>
        </el-tab-pane>
    </el-tabs>
    <add-task ref="taskAddRef" :callback="initData" />
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getTopicModelList,terminationTask} from '@/service/topicBank'
    import { getSite } from "@/service/site";
    import addTask from './addTask';
    import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
    import taskPreview from './taskPreview';
    export default {
        components: { addTask, SiteAutoComplete,taskPreview},
        name: "List",
        data () {
            return {
                list: [],
                condition: {
                    site_name:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                    type:''
                },
                isLoading: false,
                statusList:[
                    {
                        id:1,
                        name:'执行中'
                    },
                    {
                        id:2,
                        name:'已完成'
                    },
                    {
                        id:3,
                        name:'已终止'
                    },
                    {
                        id:4,
                        name:'执行异常'
                    }
                ],
                siteAll:[],
                activeTabs:"1"
            }
        },
        mounted () {
            this.initData();
            this.getSiteList();

        },
        methods: {
            async getSiteList() {
                await getSite({ owned:1, agent_status: 0, per_page: 1000 }).then((data) => {
                    this.siteAll = data.data;
                });
              
            },
            handleSearch() {
                this.condition.page=1
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    topic_name:'',
                    per_page: 10,
                    page: 1,
                }
                this.initData();
            },
            handleAdd() {
                this.$refs.taskAddRef && 
                (this.$refs.taskAddRef.siteList = this.siteAll)
                this.$refs.taskAddRef.openMenu()
            },
            openRecord(item){
                this.$router.push('model/record?id='+item.id)
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            async initData() {
                this.list=[]
                await getTopicModelList(this.condition).then((data) => {
                    this.condition.total=data.total
                    this.list = data.data
                })
                this.isLoading = false
            },
            handleStop(id) {
                this.$confirm("是否确定终止此任务？", "终止生成", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let query={
                        'record_id':id
                    }
                    terminationTask(query)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "终止成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "终止失败"
                        });
                    });
                });
            },
            handleClick(tab, event) {
                if(tab.name == '1'){
                    this.initData();
                }else if(tab.name == '2'){
                    this.$refs.taskPreviewRef.initData();
                }
            }
        }
    }
</script>

<style scoped>
.list-table {
    padding: 0 20px;
    box-sizing: border-box;
}
.baikeCat .el-select{
    width:48%;
    float:left;
}
.ellips{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>



















